import { useEffect, useState } from "react"
import { getCustomer, getUser, setSession } from "../../helpers/auth-helper"
import { t } from "i18next"
import { useNavigate } from "react-router-dom"
import { postData } from "../../helpers/api-helper"
import toast from 'react-hot-toast';

export default function ChangeProfile(props){

    const user = getUser()
    const customer = getCustomer()

    const [verification,set_verification] = useState(false)
    const [verification_code,set_verification_code] = useState("")

    const [new_full_name,set_new_full_name] = useState("")
    const [new_email,set_new_email] = useState("")
    const [loading,set_loading] = useState(false)
    const [is_email_valid,set_is_email_valid] = useState(false)

    const [seconds,set_seconds] = useState(0)

    const navigate = useNavigate()

    useEffect(() => {
        const interval = setInterval(() => {
            if(seconds > 0){
                set_seconds(seconds-1)
            }
            if(seconds === 0){
                clearInterval(interval)
            }
        },1000)

        return() => {
            clearInterval(interval)
        }
    },[seconds])

    useEffect(() => {
        const timeOutId = setTimeout(() => handleOnChange(new_email), 1500);
        return () => clearTimeout(timeOutId);
    }, [new_email]);

    const handleOnChange = ( email ) => {

        // don't remember from where i copied this code, but this works.
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        
        if ( (re.test(email) && email != "") ) {
            toast.success(t('auth.alert.email_format_valid'))
            set_is_email_valid(true)
        }else if(email != "") {
            toast.error(t('auth.alert.email_format_invalid'))
            set_is_email_valid(false)
        }
    
    }

    const applyChanges=async()=>{
        if(new_full_name !== "" || new_email !== ""){
            set_loading(true)
        }
        if(new_full_name !== ""){
            await changeName()
        }
        if(new_email !== ""){
            await changeEmail()
        }
    }

    const changeName=async()=>{
        
        var params={new_full_name,email:user.email}
        const response = await postData(`${process.env.REACT_APP_API}/change-name`,params)
        global.full_name = new_full_name
        if(response.data.status_code === 200){
            toast.success(t('auth.alert.change_name_success'))
            if(new_email == ""){
                set_loading(false)
                setSession(response.data.data_customer.remember_token,response.data.data_user,response.data.data_customer)
                navigate('/settings')
            }
        }else{
            toast.error(response.data.message)
        }
    }
    
    const changeEmail=async()=>{
        if(is_email_valid){
            var params = {email:customer.email,new_email:new_email,customer_code:customer.customer_code}
            set_loading(true)
            await postData(`${process.env.REACT_APP_API}/change-email`,params).then((response) => {
                if(response.data.status_code === 200){
                    set_verification(true)
                    toast.success(t('auth.message_verification'))
                }else{
                    toast.error(response.data.message)
                }
                set_loading(false)
            }).catch((e) => 
                set_loading(false))
        }else{
            set_loading(false)
            toast.error(t('auth.alert.email_format_invalid'))
        }
    }

    const resendToken=async()=>{
        var params = {email:new_email}
        set_loading(true)
        await postData(`${process.env.REACT_APP_API}/resend-token`,params).then((response) => {
            if(response.status === 200){
                set_seconds(10)
                toast.success(t('auth.alert.token_resended'))
            }
            set_loading(false)
        }).catch((e) => 
            set_loading(false))
    }

    const verifyToken=async ()=>{
        var params = {email:new_email,otp:verification_code,device_id:global.device_id,customer_code:customer.customer_code}
        set_loading(true)
        await postData(`${process.env.REACT_APP_API}/verify-token`,params).then((response) => {
            if(response.data.status_code === 200){
                if(response.data.data?.user){
                    set_verification(false)
                    setSession(response.data.data.data_customer.remember_token,response.data.data.data_user,response.data.data.data_customer)
                    navigate('/settings')
                    toast.success(t('auth.alert.change_email_success'))
                }
            }else{
                toast.error(response.data.message)
            }
            set_loading(false)
        }).catch((e) => 
            set_loading(false))
    }

    const FormPage=()=>{
        if(verification){
            return(
                <div className="px-16 py-10">
                    <div className="mt-10 grid px-8">
                        <h2 className='color-2'>{t('auth.message_verification')} {new_email}</h2>
                        <div className="my-5">
                            <input type="text" name="verification_code" id="verification_code" placeholder='Verification code' onChange={(e) => set_verification_code(e.target.value)} value={verification_code} className="block w-full input-1"/>
                        </div>
                    </div>
                    <div className="mt-10 px-8">
                        { loading ? 
                            <div role="status" className="mt-2 flex justify-center">
                                <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-red-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                                <span class="sr-only">Loading...</span>
                            </div> : 
                            <>
                            <div className="mt-2 flex justify-center">
                                <button className='btn-register' onClick={(e) => verifyToken()}>{t('auth.verify')}</button>
                            </div>
                            <div className="mt-2 flex justify-center">
                                <p className='color-lvl-4'>Or</p>
                            </div>
                            <div className="mt-2 flex justify-center">
                                <button className={'btn-resend'} onClick={(e) => resendToken()} disabled={seconds > 0}>{t('auth.resend')} {seconds > 0 ? "("+seconds+")" : ""}</button>
                            </div>
                        </>}
                    </div>
                </div>
            )
        }else{
            return(
                <div className="px-16 py-10">
                    <div className="mt-10 grid px-8">
                        <div className="my-2">
                            <input type="email" name="email" id="email" placeholder={t('auth.email')} value={user.email} disabled className="block w-full input-1"/>
                        </div>
                        <div className="my-2">
                            <input type="text" name="full_name" id="full_name" placeholder={t('auth.full_name')} value={user.name} disabled className="block w-full input-1"/>
                        </div>
                        <div className="my-2">
                            <input type="email" name="new_email" id="new_email" placeholder={t('auth.new_email')} onChange={(e) => set_new_email(e.target.value)} value={new_email} className="block w-full input-1"/>
                        </div>
                        <div className="my-2">
                            <input type="text" name="new_full_name" id="new_full_name" placeholder={t('auth.new_full_name')} onChange={(e) => set_new_full_name(e.target.value)} value={new_full_name} className="block w-full input-1"/>
                        </div>
                    </div>
                    <div className="mt-6 px-8">
                        { loading ? 
                        <div role="status" className="mt-2 flex justify-center">
                            <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-red-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                            </svg>
                            <span class="sr-only">Loading...</span>
                        </div> : 
                        <div className="mt-2 flex">
                            <button type='button' className='btn-register' onClick={(e) => applyChanges()}>{t('auth.apply')}</button>&nbsp; &nbsp; &nbsp; &nbsp;
                            <button type='button' className='btn-resend' onClick={(e) => navigate('/settings')}>{t('auth.cancel')}</button>
                        </div>
                        }
                    </div>
                </div>
            )
        }
    }
    
    return(
        <div className="dashboard-page" style={{height:'100vh'}}>
            <a href="/news" class="flex font-bold text-lg items-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-200 group">
                <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="current"><path d="M2.21232 14.0601C1.91928 12.6755 1.93115 11.2743 2.21316 9.94038C3.32308 10.0711 4.29187 9.7035 4.60865 8.93871C4.92544 8.17392 4.50032 7.22896 3.62307 6.53655C4.3669 5.3939 5.34931 4.39471 6.53554 3.62289C7.228 4.50059 8.17324 4.92601 8.93822 4.60914C9.7032 4.29227 10.0708 3.32308 9.93979 2.21281C11.3243 1.91977 12.7255 1.93164 14.0595 2.21364C13.9288 3.32356 14.2964 4.29235 15.0612 4.60914C15.8259 4.92593 16.7709 4.5008 17.4633 3.62356C18.606 4.36739 19.6052 5.3498 20.377 6.53602C19.4993 7.22849 19.0739 8.17373 19.3907 8.93871C19.7076 9.70369 20.6768 10.0713 21.7871 9.94028C22.0801 11.3248 22.0682 12.726 21.7862 14.06C20.6763 13.9293 19.7075 14.2969 19.3907 15.0616C19.0739 15.8264 19.4991 16.7714 20.3763 17.4638C19.6325 18.6064 18.6501 19.6056 17.4638 20.3775C16.7714 19.4998 15.8261 19.0743 15.0612 19.3912C14.2962 19.7081 13.9286 20.6773 14.0596 21.7875C12.675 22.0806 11.2738 22.0687 9.93989 21.7867C10.0706 20.6768 9.70301 19.708 8.93822 19.3912C8.17343 19.0744 7.22848 19.4995 6.53606 20.3768C5.39341 19.633 4.39422 18.6506 3.62241 17.4643C4.5001 16.7719 4.92552 15.8266 4.60865 15.0616C4.29179 14.2967 3.32259 13.9291 2.21232 14.0601ZM3.99975 12.2104C5.09956 12.5148 6.00718 13.2117 6.45641 14.2963C6.90564 15.3808 6.75667 16.5154 6.19421 17.5083C6.29077 17.61 6.38998 17.7092 6.49173 17.8056C7.4846 17.2432 8.61912 17.0943 9.70359 17.5435C10.7881 17.9927 11.485 18.9002 11.7894 19.9999C11.9295 20.0037 12.0697 20.0038 12.2099 20.0001C12.5143 18.9003 13.2112 17.9927 14.2958 17.5435C15.3803 17.0942 16.5149 17.2432 17.5078 17.8057C17.6096 17.7091 17.7087 17.6099 17.8051 17.5081C17.2427 16.5153 17.0938 15.3807 17.543 14.2963C17.9922 13.2118 18.8997 12.5149 19.9994 12.2105C20.0032 12.0704 20.0033 11.9301 19.9996 11.7899C18.8998 11.4856 17.9922 10.7886 17.543 9.70407C17.0937 8.61953 17.2427 7.48494 17.8052 6.49204C17.7086 6.39031 17.6094 6.2912 17.5076 6.19479C16.5148 6.75717 15.3803 6.9061 14.2958 6.4569C13.2113 6.0077 12.5144 5.10016 12.21 4.00044C12.0699 3.99666 11.9297 3.99659 11.7894 4.00024C11.4851 5.10005 10.7881 6.00767 9.70359 6.4569C8.61904 6.90613 7.48446 6.75715 6.49155 6.1947C6.38982 6.29126 6.29071 6.39047 6.19431 6.49222C6.75668 7.48509 6.90561 8.61961 6.45641 9.70407C6.00721 10.7885 5.09967 11.4855 3.99995 11.7899C3.99617 11.93 3.9961 12.0702 3.99975 12.2104ZM11.9997 15.0002C10.3428 15.0002 8.99969 13.657 8.99969 12.0002C8.99969 10.3433 10.3428 9.00018 11.9997 9.00018C13.6565 9.00018 14.9997 10.3433 14.9997 12.0002C14.9997 13.657 13.6565 15.0002 11.9997 15.0002ZM11.9997 13.0002C12.552 13.0002 12.9997 12.5525 12.9997 12.0002C12.9997 11.4479 12.552 11.0002 11.9997 11.0002C11.4474 11.0002 10.9997 11.4479 10.9997 12.0002C10.9997 12.5525 11.4474 13.0002 11.9997 13.0002Z"></path></svg>
                <span class="ms-3">{t('settings.change_profile')}</span>
            </a>    
            {FormPage()}
        </div>
    )
}